import { get, post, put, del } from 'utils/methods';

export function addNewPropertyApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/property`, data, headers);
}

export function editPropertyApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/property`, data, headers);
}

export function updatePropertyTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/property/translate`, data, headers);
}

export function getPropertiesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}properties`, data, headers);
}

export function getPropertyValuesApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}properties-values`, data, headers);
}

export function addPropertyValueToPropertyApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/property/property-value`, data, headers);
}

export function editPropertyValueToPropertyApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/property/property-value`, data, headers);
}

export function updatePropertyValueTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/property/property-value/translate`, data, headers);
}

export function deletePropertyValueApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/property/property-value`, data, headers);
}
